module.exports = __webpack_public_path__ + "static/media/me2.3e4a63e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/me2.png
// module id = 28
// module chunks = 0